import React, { useState, useContext, useEffect } from 'react';
import axios from 'axios';
import { useSpring, animated } from 'react-spring';
import {  useParams } from 'react-router-dom';

import { Navbar } from '../Components/Navbar';
import { FormTextInput } from '../Components/FormTextInput';
import { AltAnimatedButton } from '../Components/AltAnimatedButton';
import { Footer } from '../Components/Footer';
import { useScreenTransition } from '../Hooks/useScreenTransition';
import { useEnterKey } from '../Hooks/useEnterKey';
import { TransitionContext } from '../Context/TransitionContext';
import { NotificationContext } from '../Context/NotificationContext';
import { AuthContext } from '../Context/AuthContext';
import TopBar from '../Components/TopBar';

import './CreateAccount.css';
import { auth, getFullHttpUrl } from '../firebase.config';
import Loader from '../NewComponents/Loader';

const JoinTeam = ({ windowSize }) => {

  const { transitionTo } = useScreenTransition();

  const { setColor } = useContext(TransitionContext);

  const { showNotification } = useContext(NotificationContext);

  const { signedIn, setSignedIn } = useContext(AuthContext);

  useEffect(() => {
    setColor(true);
  }, [setColor]);

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirm] = useState('');
  const [loading, setLoading] = useState(true);
  const statusOverlayProps = useSpring({ display: loading ? "flex" : "none",});

  const [submitButton, setSubmitButton] = useState('Submit');

  const { inviteID } = useParams();


  const addMember = async() => {

    await axios({
      method: "post",
      url: getFullHttpUrl("team-addMemberFromInvitation"),
      data: {
          id: inviteID,
        },
    })
      .then(async (res) => {
        if(res.data.status === "member-updated"){
          if(signedIn){auth.signOut();}
          showNotification(
            "Success", 
            "Team Joined Successfully, please login to your account.",
            "success"
          );
          transitionTo("/");
        }else if(res.data.status === "no-invites"){
          // showNotification(
          //   "No Invitation found", 
          //   "No Invitation found, please ask team owner/admin to send team invitation again.",
          //   "error"
          // );
          transitionTo("/");
        }else if(res.data.status === "member-created"){
          if(signedIn){auth.signOut();}
          auth.signInWithEmailAndPassword(res.data.inviteData.email, res.data.password)
          .then((userCredential) => {
            // transitionTo(`/account/settings?tab=change-pass&&pass=${res.data.password}`);
            // const user = userCredential.user
            // setName(res.data.inviteData.name);
            // setEmail(user.email);
            setSignedIn(true);
            // setLoading(false);
            transitionTo(`/account/team-members`);
            showNotification("Success", "Team Joined Successfully.", "success");
          })
          .catch((error) => {
              showNotification("Error", "There was an error. Please, try again or refresh the page.", "error");
              // console.log(error)
          });
        }
        
      }).catch(e => {
        showNotification('Error', "There was an error. Please, try again or refresh the page.", 'error');
      }
      );
  }

  useEffect(()=> {
    if(inviteID){
        addMember();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inviteID])

  const setNewPassword = () => {
    setSubmitButton("Submitting...");

    const user = auth.currentUser;

    user.updatePassword(password).then(() => {
    // Update successful.
        setSubmitButton("Submit");
        showNotification("Success", "New Password Created successfully", "success");
        transitionTo('/account/profile');
    })
      .catch(error =>  {
        var errorCode = error.code;
        setSubmitButton("Submit");

        switch(errorCode) {
          case "auth/invalid-email":
            showNotification("Invalid Email", "The email address is invalid. Please, try again.", "error");
            break;
          case "auth/weak-password":
            showNotification("Weak Password", "The password is too weak. Please, try again.", "error");
            break;
          default:
            showNotification("Error", "An unexpected error ocurred. Please, try again.", "error");
        }
      });
  }

  const triggerSetPassword = () => {
    if (!(name === "" || email === "" || password === "" || confirmPassword === "" || password !== confirmPassword)) {
      setNewPassword();
    }
  }

  useEnterKey(() => triggerSetPassword());

  if (loading) {
    return (
      <div className="container mx-auto w-full h-dvh flex items-center justify-center">
        <Loader />
      </div>
    );
  }

  return (
    <>
    <TopBar/>

    {loading && <animated.div style={statusOverlayProps} className="checkoutStatusOverlay">
    Loading , Please wait<span className="dotsLoading">...</span>
  </animated.div>}
   
    <div className="homeContainer">
      <Navbar windowSize={windowSize} />
            {email ?
      <div className="createAccountContainer">
        <div className="createAccountInfoContainer">
          <h1 className="documentsHeading">Change your Team Account Password</h1>
          <h2 className="subheading">Access your team quote and order history, saved addresses, payment methods, and site preferences anytime.</h2>
        </div>
        <div className="createAccountFormContainer">
          <FormTextInput disabled placeholder="Name" value={name} onChange={setName} color='#666' />
          <FormTextInput disabled placeholder="Email" value={email} onChange={setEmail} color='#666' />
          <FormTextInput password placeholder="Password" value={password} onChange={setPassword} color='#666' />
          <FormTextInput password placeholder="Confirm Password" value={confirmPassword} onChange={setConfirm} color='#666' />
          <div className="createAccountFormSeparator" />
          <AltAnimatedButton text={submitButton} onClick={() => setNewPassword()} disabled={name === "" || email === "" || password === "" || confirmPassword === "" || password !== confirmPassword} fontSize={windowSize.width > 1024 ? 1.1 : windowSize.width > 767 ? (windowSize.orientation === 'portrait' ? 1.6 : 1.1) : (windowSize.orientation === 'portrait' ? 5 : 1.5)}/>
        </div>
      </div>
           :  <div className="createAccountContainer">
            <h1 className="documentsHeading">{loading ? "Loading, Please wait..." : "No Account found..."}</h1>
            </div>}
      <Footer windowSize={windowSize} />
    </div>
    </>
  );
}

export default JoinTeam;